// extracted by mini-css-extract-plugin
export var alternate = "_15-h";
export var black = "_15-3";
export var blue = "_15-d";
export var blueLight = "_15-c";
export var brand = "_15-7";
export var error = "_15-9";
export var gray = "_15-6";
export var grayBlue = "_15-b";
export var iconWrapper = "_15-4";
export var indigo = "_15-e";
export var orange = "_15-g";
export var pink = "_15-f";
export var primary = "_15-0";
export var purple = "_15-8";
export var success = "_15-5";
export var warning = "_15-a";
export var white = "_15-1";
export var whiteSuccess = "_15-2";